import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_v_alert, {
        color: "primary",
        text: ""
      }, {
        default: _withCtx(() => [
          _cache[0] || (_cache[0] = _createElementVNode("h2", null, "メンテナンスモード", -1)),
          _cache[1] || (_cache[1] = _createElementVNode("div", null, "現在メンテナンス中です。しばらくお待ちください。", -1)),
          _createVNode(_component_v_divider, {
            class: "info my-6",
            style: {"opacity":"0.22"}
          }),
          _createElementVNode("div", null, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.maintenanceMessage), 1)
          ])
        ]),
        _: 1
      })
    ])
  ]))
}